module.exports = __webpack_public_path__ + "e5947ee873600dd1cae20e30cf80ee68.ttf";